module.exports = __webpack_public_path__ + "static/media/MHRP29N0021.ea87e1d7.svg";